import { Checkbox } from 'antd'
import type { FC } from 'react'

import { QueryKeyENUM } from '../../atoms/Filters/ApplyFilters.model'
import type { IFilterProps } from '../ApplyFilters.model'
import { SFilterBlock } from '../Filters.styled'

export const AdaptationFilter: FC<IFilterProps> = ({
  setFilters,
  prevState,
}) => (
  <SFilterBlock>
    <Checkbox
      checked={String(prevState?.value) === 'true'}
      onChange={(event) =>
        setFilters(
          QueryKeyENUM.adaptationProgram,
          event.target.checked
            ? { value: 'true', name: 'Для детей с ОВЗ' }
            : null,
        )
      }>
      Для детей с ОВЗ
    </Checkbox>
  </SFilterBlock>
)
